import { AssetImage, Icon } from "@ospweb/sdk-ui";
import { useRedirectChat } from "@hooks";

export interface UserInfoProps {
  token?: string;
  icon?: string;
}
export const UserInfo = ({ token, icon }: UserInfoProps) => {
  const { handleCheckChatVaild } = useRedirectChat();

  const onClick = () => {
    handleCheckChatVaild({
      question: token || "",
      sign: "token",
    });
  };
  return (
    <div
      data-openreplay-label="kolStatus · UserInfo · div"
      className="z-10 flex items-center gap-1 cursor-pointer flex-shrink-0"
      onClick={onClick}
    >
      <AssetImage
        src={icon || ""}
        className="w-4 h-4 rounded-full"
        alt="icon"
        width={16}
        height={16}
      />
      <span className="body_medium_m text-content_primary">{token}</span>
      <Icon name="search" color="#1ED1E9" size={12} />
    </div>
  );
};
